import { Injectable } from '@angular/core';
import { TIME_OF_DAY } from '../../enums/time-of-day.enum';

@Injectable({ providedIn: 'root' })
export class TimeService {
	private static readonly MORNING = 0;
	private static readonly AFTERNOON = 12;
	private static readonly EVENING = 17;

	static getTimeOfDay(): number {
		const currHour = new Date().getHours();
		let timeOfDay;

		if (currHour >= TimeService.MORNING && currHour < TimeService.AFTERNOON) {
			timeOfDay = TIME_OF_DAY.MORNING;
		} else if (
			currHour >= TimeService.AFTERNOON &&
			currHour < TimeService.EVENING
		) {
			timeOfDay = TIME_OF_DAY.AFTERNOON;
		} else if (
			currHour >= TimeService.EVENING ||
			currHour < TimeService.MORNING
		) {
			timeOfDay = TIME_OF_DAY.EVENING;
		}

		return timeOfDay;
	}
}
